// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");

function make(fn, timeOut) {
  var id = {
    contents: null
  };
  return function (a) {
    Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(id.contents), undefined, (function (prim) {
            clearTimeout(prim);
          }));
    id.contents = setTimeout((function (param) {
            Curry._1(fn, a);
          }), timeOut);
  };
}

exports.make = make;
/* No side effect */
